import React, { useEffect, Component, useState, useRef } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { useHistory, useParams } from 'react-router-dom';
import { ApiService } from '../../containers/Services/apiservice';
import * as moment from 'moment';
import { Watch } from "react-loader-spinner";
let apiServices = new ApiService();
const EPayEezz = () => {
  let history = useHistory();
  const didMountRef = useRef(true);
  const [Bankno, setBankno] = useState();
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [Message, setMessage] = useState('');
  const [UserBankData, SetUserBankData] = useState({});
  const [AuthMode, setAuthMode] = useState('');
  const [MaxAmt, setMaxAmt] = useState();
  useEffect(() => {
    if (didMountRef.current) {
      getusrbanks();
    }
    didMountRef.current = false;
  });
  const getusrbanks = () => {
    const dataString = {
    }
    apiServices.getusercanbankdata(dataString).then(res => {
      if (res.data.status == 'success') {
        SetUserBankData(res.data.data)
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(res.data.message)
        setSpinnerLoading(false)
      }
    }
    )
  }
  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }
  const ePayEezzReg = () => {
    if (AuthMode == '' || AuthMode == undefined || AuthMode == null) {
      setMessage('Please Select Authentication Mode.');
      return false;
    }
    if (MaxAmt == '' || MaxAmt == undefined || MaxAmt == null) {
      setMessage('Maximum Amount Field Is Required');
      return false;
    }
    if (MaxAmt < 10000 || MaxAmt > 1000000) {
      setMessage('Maximum Amount Value Should Be Between 10000 To 1000000');
      return false;
    }
    setSpinnerLoading(true);
    const dataString = {
      "maxamt": MaxAmt,
      "authmode": AuthMode,
      "bankno": Bankno
 }
    apiServices.epayeezzregistration(dataString).then(res => {
      // return false;
      if (res.data.respStatus == '0') {
        setTimeout(() => {
          history.push("/dashboard");
        }, 3000);
        setSpinnerLoading(false);
        openInNewTab(res.data.addResp.approveLink)
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert('Something went wrong please try again later');
        // window.location.reload();
        setSpinnerLoading(false);
        return false;
      }
    }
    )
  }
  return (
    <div>
      <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
        <div className='overlay-box'>
          <Watch
            color="#ffffff"
            visible={spinnerLoading}
          />
        </div>
      </div>
      <Header />
   <section className='bg-gray-light section-small'>
        <div className="container">
          <div className="row justify-content-md-center mb-50">
            <div className="col-lg-8">
              <h4 className="text-center mb-40 tx-theme">Let’s Register your ePayEezz</h4>
              <div className="goalset">
                {/* <h6>Find out the future value of your Goal & your Monthly Investment to achieve it</h6> */}
                <div className="gform mt-20">
                  <div className='row'>
                    <div className='col-lg-12'>
                      <div className="gform-box mg-b-20">
                        <label>Select Bank Detail</label>
                        {/* <label>Select Bank Details<span style={{color:'#ff0000'}}>*</span></label> */}
                        <select name="bankno" value={Bankno} onChange={(e) => setBankno(e.target.value)}>
                          {UserBankData.crb_bank_acc_no1 != null ?
                            <option value="1">{UserBankData.crb_bank1} -- {UserBankData.crb_bank_acc_no1.replace(/.(?=.{4})/g, 'X')} -- (Primary)</option> : ''
                          }
                          {UserBankData.crb_bank_acc_no2 != null ?
                            <option value="2">{UserBankData.crb_bank2} -- {UserBankData.crb_bank_acc_no2.replace(/.(?=.{4})/g, 'X')}</option> : ''
                          }
                          {UserBankData.crb_bank_acc_no3 != null ?
                            <option value="3">{UserBankData.crb_bank3} -- {UserBankData.crb_bank_acc_no3.replace(/.(?=.{4})/g, 'X')}</option> : ''
                          }
                        </select>
                      </div>
                    </div>
                    <div className='col-lg-12'>
                      <div className="gform-box mg-b-20">
                        <label>Select Authentication Mode</label>
                        <select onChange={(e) => setAuthMode(e.target.value)}>
                          <option value="">Select Authentication Mode</option>
                          <option value="PD">Debit Card</option>
                          <option value="PN">Net Banking</option>
                        </select>
                      </div>
                    </div>
                    <div className='col-lg-12'>
                      <div className="gform-box mg-b-20">
                        <label>Maximum Amount</label>
                        <input type="number" onChange={(e) => { setMaxAmt(e.target.value) }} />
                        <small>
                          Min : 10,000          Max:1,000,000
                        </small>
                      </div>
                    </div>
                  </div>
                  {
                    Message != null || Message != '' || Message != undefined ?
                      <p style={{ color: '#ff0000' }}>{Message}</p> : ''
                  }
                  <button type="button" onClick={ePayEezzReg} className="btn btn-primary mt-10 button01">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
export default EPayEezz;